import { ReactNode } from "react";
import { ExternalLink } from './ExternalLink';

export const publicLink = (to: string) => `${process.env.REACT_APP_PUBLIC_URL}/${to}`;

export const PublicLink = ({ to, children, color = 'inherit' }:{ to: string, children: ReactNode, color: string }) => <ExternalLink to={publicLink(to)} color={color}>{children}</ExternalLink>